<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs6>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-layout>
                <v-flex class="mr-1" xs6>
                  <v-autocomplete
                    :loading="loading"
                    v-model="entity"
                    :items="reviewedEntities"
                    cache-items
                    :search-input.sync="searchTerm"
                    hide-details
                    return-object
                    item-text="title"
                    item-value="title"
                    placeholder="Select Entity"
                    no-data-text="Type a name of an entity to search"
                    outlined
                    chips
                    dense
                    @change="entitySelected"
                  ></v-autocomplete>
                </v-flex>
                <v-flex class="ml-1" xs6>
                  <v-select
                    outlined
                    dense
                    hide-details
                    return-object
                    :items="regionsWithAll"
                    v-model="selectedRegion"
                    item-text="name"
                    placeholder="Select Region"
                    @change="selectRegion"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex text-right>
              <v-btn
                class="mr-2"
                @click="openNewRawPinDialog"
                depressed
                color="primary"
              >
                Create Raw Pin
              </v-btn>
              <v-btn @click="openNewPinDialog" depressed color="primary">
                Create Pin
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between class="mt-2">
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs3 text-right v-if="selectedRegion.name !== 'All'">
              <v-select
                hide-details
                outlined
                placeholder="Filter By Status"
                dense
                v-model="selectedState"
                @change="stateSelected"
                :items="[
                  'all',
                  'active',
                  'scheduled',
                  'updated',
                  'expired',
                  'deleted',
                ]"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="pins"
        :loading="loading"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available, Select a region to start"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon>
        </template>
        <template v-slot:item.data.image="{ item }">
          <div style="min-width: 50px">
            <v-icon small v-if="item.data.image"> mdi-paperclip </v-icon>
          </div>
        </template>
        <template v-slot:item.scheduledAt="{ item }">
          <div style="min-width: 100px">
            {{ iMoment(item.scheduledAt) }}
          </div>
        </template>
        <template v-slot:item.title="{ item }">
          <div style="min-width: 100px">
            {{ item.entity.title }}
          </div>
        </template>
        <template v-slot:item.pinType.name="{ item }">
          <div style="min-width: 80px">
            {{ item.pinType.name }}
          </div>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div style="min-width: 100px">
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <new-raw-pin-dialog
      :selectedRegion="selectedRegion"
      :collection="collection"
      ref="newRawPinDialog"
    />
    <new-pin-dialog
      :selectedRegion="selectedRegion"
      :collection="collection"
      ref="newPinDialog"
    />
    <edit-raw-pin-dialog
      :selectedRegion="selectedRegion"
      :pinDetail="editedItem"
      :collection="collection"
      ref="editRawPinDialog"
    />
    <edit-pin-dialog
      :selectedRegion="selectedRegion"
      :pinDetail="editedItem"
      :collection="collection"
      ref="editPinDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewPinDialog from "../components/NewPinDialog";
import NewRawPinDialog from "../components/NewRawPinDialog";
import EditPinDialog from "../components/EditPinDialog.vue";
import EditRawPinDialog from "../components/EditRawPinDialog.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
  components: {
    NewRawPinDialog,
    NewPinDialog,
    EditPinDialog,
    EditRawPinDialog,
  },
  data() {
    return {
      selectedRegion: {},
      searchTerm: "",
      entity: null,
      selectedState: "",
      collection: "pipeline",
      loading: false,

      search: "",
      dialogDelete: false,
      itemToDelete: {
        scheduledAt: "",
        state: "",

        data: {
          expiresAt: "",
          content: "",
          graphics: {
            entity: "",
            icon: {
              bgColor: "",
              color: "",
              name: "",
              type: "",
            },
          },
          image: {
            thumbnail: "",
            url: "",
          },
          isMarker: "",
          location: "",
          score: "",

          totalComments: "",
          type: "",
          views: "",
        },
      },
      headers: [
        {
          text: "Content",
          align: "start",
          sortable: true,
          value: "data.content",
        },
        // { text: "Font Family", value: "fontFamily" },
        { text: "Photo", value: "data.image" },
        { text: "Pin Type", value: "pinType.name" },
        { text: "Entity", value: "entity.title" },

        { text: "Scheduled At", value: "scheduledAt" },
        // { text: "Placement", value: "data.placement" },
        { text: "State", value: "state" },
        // { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        scheduledAt: "",
        state: "",
        data: {
          content: "",
          graphics: {
            entity: "",
            icon: {
              bgColor: "",
              color: "",
              name: "",
              type: "",
            },
          },
          image: {
            thumbnail: "",
            url: "",
          },
          isMarker: "",
          location: "",
          score: "",

          totalComments: "",
          type: "",
          views: "",
        },
      },
      editedIndex: -1,
      defaultItem: {
        scheduledAt: "",
        state: "",
        data: {
          content: "",
          graphics: {
            entity: "",
            icon: {
              bgColor: "",
              color: "",
              name: "",
              type: "",
            },
          },
          image: {
            thumbnail: "",
            url: "",
          },
          isMarker: "",
          location: "",
          score: "",

          totalComments: "",
          type: "",
          views: "",
        },
      },
    };
  },
  computed: {
    ...mapState("$_content", ["pins"]),
    ...mapState("$_home", ["regions"]),
    ...mapState("$_entity", ["reviewedEntities"]),
    regionsWithAll() {
      var arr = [];
      arr.push({ name: "All" });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  watch: {
    searchTerm: _.debounce(function (e) {
      e && this.searchEntities(e);
    }, 300),
  },
  created() {
    if (this.regions.length === 0) {
      this.getRegions({ collection: "regions", mutation: "updateRegions" });
    }
  },
  methods: {
    ...mapActions({
      getPins: "$_content/getContent",
      getPinsByRegion: "$_content/getContentByRegion",
      getPinsByEntity: "$_content/getContentByEntity",
      getPinsByRegionByState: "$_content/getContentByRegionByState",
      getPinsByEntityByState: "$_content/getContentByEntityByState",
      deletePin: "$_content/deleteContent",
      getRegions: "$_home/getContent",
      searchEntitiesAction: "$_entity/searchContent",
    }),
    searchEntities(searchTerm) {
      //this.loading = true;
      console.log("searching Tags: ", searchTerm);

      this.searchEntitiesAction({
        collection: "entities",
        mutation: "updateReviewedEntities",
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    stateSelected(state) {
      this.selectedState = state;
      if (this.entity) {
        if (this.selectedState == "all") {
          this.getPinsByEntity({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            entity: this.entity,
          });
        } else {
          this.getPinsByEntityByState({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            entity: this.entity,
            state: this.selectedState,
          });
        }
      } else if (this.selectedRegion) {
        if (this.selectedState == "all") {
          this.getPinsByRegion({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            region: this.selectedRegion,
          });
        } else {
          this.getPinsByRegionByState({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            region: this.selectedRegion,
            state: this.selectedState,
          });
        }
      }
    },
    entitySelected(entity) {
      console.log(entity);
      if (this.selectedState === "") {
        this.selectedState = "active";
      }
      this.selectedRegion = entity.region;
      if (this.selectedState === "all") {
        this.getPinsByEntity({
          type: "pin",
          collection: this.collection,
          mutation: "updatePins",
          entity: entity,
        });
      } else {
        this.getPinsByEntityByState({
          type: "pin",
          collection: this.collection,
          mutation: "updatePins",
          entity: entity,
          state: this.selectedState,
        });
      }
    },
    selectRegion() {
      // console.log("selectedRegion: ", this.selectedRegion);
      this.entity = null;
      if (this.selectedRegion.name === "All") {
        this.loading = true;
        this.getPins({
          type: "pin",
          collection: this.collection,
          mutation: "updatePins",
        }).then(() => {
          this.loading = false;
        });
      } else {
        if (this.selectedState === "all") {
          this.getPinsByRegion({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            region: this.selectedRegion,
          });
        } else if (
          this.selectedState === "active" ||
          this.selectedState === ""
        ) {
          console.log("Region: ", this.selectedRegion);
          if (this.selectedRegion.name !== "All") {
            this.selectedState = "active";
          }

          this.getPinsByRegionByState({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            region: this.selectedRegion,
            state: this.selectedState,
          });
        } else {
          this.getPinsByRegionByState({
            type: "pin",
            collection: this.collection,
            mutation: "updatePins",
            region: this.selectedRegion,
            state: this.selectedState,
          });
        }
      }
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewPinDialog() {
      this.$refs.newPinDialog.toggleDialog();
    },
    openNewRawPinDialog() {
      this.$refs.newRawPinDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.pins.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.pins[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      //this.$refs.editPinDialog.toggleDialog(this.editedItem);
      if (this.editedItem.entity) {
        this.$refs.editPinDialog.toggleDialog(this.editedItem);
      } else {
        this.$refs.editRawPinDialog.toggleDialog(this.editedItem);
      }
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.pins.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, this.pins[this.editedIndex]);

      // console.log("Edited Item: ", this.editedItem);

      //this.$refs.editPinDialog.toggleDialog(this.editedItem, "copy");
      if (this.editedItem.entity) {
        this.$refs.editPinDialog.toggleDialog(this.editedItem, "copy");
      } else {
        this.$refs.editRawPinDialog.toggleDialog(this.editedItem, "copy");
      }
    },
    deleteItem(item) {
      this.editedIndex = this.pins.indexOf(item);
      this.itemToDelete = Object.assign({}, this.pins[this.editedIndex]);
      this.itemToDelete.state = "deleted";
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deletePin({
        details: this.itemToDelete,
        collection: this.collection,
        type: "Pin",
      }).then(() => {
        this.dialogDelete = false;
        if (this.selectedRegion) {
          this.selectRegion();
        }
      });
    },
  },
};
</script>

<style>
</style>